import { NavLink, useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import './Navbar.css';
import logo from '../../Images/GeoParkingLogo.png'; // Adjust the path as necessary
import PopUPModal from '../utils/Modal'
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../utils/msalConfig";
import { silentRequest } from "../utils/msalConfigB2C.js";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import Cookies from 'js-cookie';
import { useUser } from "../utils/UserContext.jsx"; // Import the custom hook
import { useMsalInstances } from "../utils/MsalInstancesContext";
import { Divider } from '@mui/joy';
import warniningIcon from '../../Images/warning.png'
import userPlus from './UserPlus.png'
import copy from './copy.png';
import user from './User.png'
import { signinRequest } from "../utils/msalConfigB2C";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchLinkedAccounts, fetchUserDetailsByEmailId, fetchUsersWithValidEmpId } from '../../Services/userService.js';
import { setMaxLinkedOrganizations } from '../../config/appSettings.js';
import {
    canAddLinkedOrganization,
    getLinkedOrganizationLimitValidationMessage,
    wouldExceedLinkedOrganizationLimit,
} from '../../utils/linkedOrganizations.js';

const Navbar = ({ mapvisible, setMapvisible }) => {
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const clientIdB2C = process.env.REACT_APP_CLIENT_ID_ENTRA;
    const navigate = useNavigate();
    const [showPopup1, setShowPopup1] = useState(false);
    const SESSION_TIMEOUT = 20 * 60 * 1000; // 20 minutes
    const WARNING_TIME = 60 * 1000; // Show popup for the last 60 seconds
    const [showPopup, setShowPopup] = useState(false);
    const [countdown, setCountdown] = useState(60);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const toggleDropdown = () => setIsDropdownVisible(!isDropdownVisible);
    const envname = process.env.REACT_APP_ENV_TXT || null;
    const activityTimeoutRef = useRef(null);
    const countdownIntervalRef = useRef(null);
    const [tooltip] = useState({ show: false, text: "", position: { top: 0, left: 0 } });
    const [nextRoute, setNextRoute] = React.useState(null);
    const [openDialog, setOpenDialog] = React.useState(false);
    const { } = useMsal();
    const { azureADInstance, b2cInstance } = useMsalInstances();
    const { userDetails } = useUser();
    const { initial } = useUser();
    const { empDetails, employeeData } = useUser();
    const [isLoginInProgress, setIsLoginInProgress] = useState(false);
    const LINKED_ACCOUNTS_STORAGE_KEY = "navbar.linkedAccounts";
    // Keep this state server-driven so deleted organizations do not linger from
    // a previous sessionStorage cache.
    const [accounts, setAccounts] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isAccountSettingsOpen, setIsAccountSettingsOpen] = useState(false);
    const rootRef = useRef(null);

    const getAccountKey = (account = {}) =>
        (account?.oid || account?.Oid || account?.emailId || account?.EmailId || account?.email || "")
            .toString()
            .toLowerCase();

    const isDeletedAccount = (account = {}) => {
        const deletedValue = account?.isDeleted ?? account?.IsDeleted ?? account?.deleted ?? account?.Deleted;
        const status = (account?.status || account?.Status || "").toString().toLowerCase();
        return deletedValue === true ||
            deletedValue === "true" ||
            deletedValue === 1 ||
            deletedValue === "1" ||
            status === "deleted" ||
            status === "removed";
    };

    const normalizeLinkedAccount = (account = {}) => ({
        oid: account.oid || account.Oid || account.oidValue || account.id || null,
        emailId: account.emailId || account.EmailId || account.email || null,
        role: account.role || account.Role || account.title || "",
        companyName: account.companyName || account.CompanyName || account.entityName || account.company || "",
        firstName: account.firstName || account.FirstName || account.first || "",
        lastName: account.lastName || account.LastName || account.last || ""
    });

    const uniqueActiveAccounts = (accountList = []) => {
        const map = new Map();
        (Array.isArray(accountList) ? accountList : [])
            .filter(account => !isDeletedAccount(account))
            .map(normalizeLinkedAccount)
            .forEach(account => {
                const key = getAccountKey(account);
                if (key && !map.has(key)) map.set(key, account);
            });
        return Array.from(map.values());
    };

    const extractLinkedAccounts = (payload = {}) => {
        let linked = payload.linkedAccounts || payload.LinkedAccounts || payload.LinkedLLCs || payload.linkedLLCs || [];
        if (!Array.isArray(linked) || linked.length === 0) {
            const groups = payload.groups || payload.Groups || [];
            linked = (groups || []).flatMap(group => group.linkedLLCs || group.LinkedLLCs || group.linkedLLCs || []);
        }
        if (!Array.isArray(linked) || linked.length === 0) {
            linked = payload.accounts || payload.Accounts || [];
        }
        return uniqueActiveAccounts(linked);
    };

    const keepOnlyExistingOwners = async (accountList = []) => {
        try {
            const activeOwners = await fetchUsersWithValidEmpId();
            if (Array.isArray(activeOwners)) {
                return accountList
                    .map(account => {
                        const activeOwner = activeOwners.find(owner => accountsMatch(account, {
                            oid: owner.userId,
                            emailId: owner.emailId || owner.email,
                        }));
                        if (!activeOwner || isDeletedAccount(activeOwner)) return null;

                        return {
                            ...account,
                            companyName: activeOwner.entityName || activeOwner.companyName || account.companyName,
                            firstName: activeOwner.firstName || account.firstName,
                            lastName: activeOwner.lastName || account.lastName,
                        };
                    })
                    .filter(Boolean);
            }
        } catch (error) {
            console.error("Unable to load active owner list for linked organizations:", error);
        }

        const checks = await Promise.all(
            accountList.map(async account => {
                if (!account.emailId) return account;

                try {
                    const ownerDetails = await fetchUserDetailsByEmailId(account.emailId);
                    if (!ownerDetails || isDeletedAccount(ownerDetails)) return null;

                    return {
                        ...account,
                        companyName: ownerDetails.entityName || ownerDetails.companyName || account.companyName,
                        firstName: ownerDetails.firstName || account.firstName,
                        lastName: ownerDetails.lastName || account.lastName,
                    };
                } catch (error) {
                    console.error("Unable to verify linked organization:", account.emailId, error);
                    return null;
                }
            })
        );

        return checks.filter(Boolean);
    };

    const fetchActiveLinkedAccounts = async () => {
        const response = await fetchLinkedAccounts();
        if (response?.success === false) {
            throw new Error(response.message || "Unable to verify linked organizations.");
        }
        const payload = response?.success ? response.data : response || {};
        const apiLimit =
            payload.maxLinkedOrganizations ??
            payload.MaxLinkedOrganizations ??
            payload.applicationSettings?.maxLinkedOrganizations ??
            payload.ApplicationSettings?.MaxLinkedOrganizations;
        if (apiLimit != null) {
            setMaxLinkedOrganizations(apiLimit);
        }
        const linkedAccounts = extractLinkedAccounts(payload);
        return keepOnlyExistingOwners(linkedAccounts);
    };

    const upsertPrimaryAccount = (accountList = [], primaryAccount = null) => {
        if (!primaryAccount) return accountList;
        const normalizedPrimary = normalizeLinkedAccount(primaryAccount);
        const primaryKey = getAccountKey(normalizedPrimary);
        if (!primaryKey) return accountList;

        const withoutPrimary = accountList.filter(account => getAccountKey(account) !== primaryKey);
        return [normalizedPrimary, ...withoutPrimary];
    };

    const removeAccount = (accountToRemove = {}) => {
        const removeKey = getAccountKey(accountToRemove);
        if (!removeKey) return;
        setAccounts(prev => (prev || []).filter(account => getAccountKey(account) !== removeKey));
    };

    const accountsMatch = (left = {}, right = {}) => {
        const leftOid = (left.oid || left.Oid || "").toString().toLowerCase();
        const rightOid = (right.oid || right.Oid || "").toString().toLowerCase();
        const leftEmail = (left.emailId || left.EmailId || left.email || "").toString().toLowerCase();
        const rightEmail = (right.emailId || right.EmailId || right.email || "").toString().toLowerCase();

        return Boolean((leftOid && rightOid && leftOid === rightOid) || (leftEmail && rightEmail && leftEmail === rightEmail));
    };

    // Persist only the current verified list for debugging/continuity; it is
    // never used as the initial source of truth.
    useEffect(() => {
        try {
            sessionStorage.setItem(LINKED_ACCOUNTS_STORAGE_KEY, JSON.stringify(accounts || []));
        } catch {
            // ignore quota errors
        }
    }, [accounts]);

    useEffect(() => {
        const interval = setInterval(() => {
            acquireToken();
            acquireB2CToken();
        }, 50 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    const acquireToken = async () => {
        try {
            const accounts = azureADInstance.getAllAccounts();
            if (accounts.length === 0) throw new Error("No user is logged in.");
            const response = await azureADInstance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0], // Provide the account information
            });
            console.log("New access token acquired:", response);
            Cookies.set("idToken", response.idToken);
        } catch (error) {
            console.error("Token acquisition failed:", error);
            if (error instanceof InteractionRequiredAuthError) {
                const response = await azureADInstance.acquireTokenPopup(loginRequest);
                Cookies.set("idToken", response.idToken);
            }
        }
    };
    const acquireB2CToken = async () => {
        try {
            const accounts = b2cInstance.getAllAccounts();
            if (!accounts || accounts.length === 0) throw new Error("No user is logged in.");

            const response = await b2cInstance.acquireTokenSilent({
                ...silentRequest,
                account: accounts[0], // Provide the account information
            });

            console.log("New access token acquired:", response);
            Cookies.set("idToken", response.accessToken);
            return response; // <--- return for callers
        } catch (error) {
            console.error("Token acquisition failed:", error);

            // If interaction is required, fall back to popup and return its response
            if (error instanceof InteractionRequiredAuthError) {
                const response = await b2cInstance.acquireTokenPopup(silentRequest);
                Cookies.set("idToken", response.accessToken);
                return response;
            }

            // rethrow other errors so callers can handle them
            throw error;
        }
    };
    const startCountdown = () => {
        countdownIntervalRef.current = setInterval(() => {
            setCountdown(prevCount => {
                const nextCount = prevCount - 1;
                if (nextCount === 0) {
                    clearInterval(countdownIntervalRef.current);
                    handleLogout();
                }
                return nextCount;
            });
        }, 1000);
    };
    const handleLogout = (e) => {
        // e.preventDefault();
        setShowPopup(false);
        try { sessionStorage.removeItem(LINKED_ACCOUNTS_STORAGE_KEY); } catch { /* ignore */ }
        localStorage.clear();
        sessionStorage.clear();
        document.cookie.split(";").forEach((cookie) => {
            document.cookie = cookie
                .replace(/^ +/, "")
                .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
        });
        if (envname === "Engineering" || envname === "DEMO") {
            navigate("/");
        }
        else
            navigate('/login');
    };
    const handleStayLoggedIn = () => {
        setShowPopup(false);
        setCountdown(60);
        clearTimeout(activityTimeoutRef.current);
        clearInterval(countdownIntervalRef.current);
        activityTimeoutRef.current = setTimeout(() => {
            setShowPopup(true);
            startCountdown();
        }, SESSION_TIMEOUT - WARNING_TIME);
    };
    const handleConfirmNavigate = () => {
        setShowPopup1(false);
        if (nextRoute) {
            navigate(nextRoute);
            setNextRoute(null);
        }
    };
    const handleCancelNavigate = () => {
        setShowPopup1(false);
        setOpenDialog(false)
    };
    const handleConfirmNavigation = () => {
        setOpenDialog(false);
        setMapvisible(false);
        if (nextRoute) {
            navigate(nextRoute)
        }
    };

    const handleNavigation = (event, route) => {
        if (mapvisible) {
            event.preventDefault();
            setOpenDialog(true)
            setNextRoute(route);
        } else {
            navigate(route);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const dropdown = document.querySelector('.profile-dropdown');
            if (dropdown && !dropdown.contains(event.target)) {
                setIsDropdownVisible(false);
            }
        };
        if (isDropdownVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownVisible]);


    useEffect(() => {
        function handleClickOutside(event) {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setIsOpen(false);          // close main popup
                setIsAccountSettingsOpen(false); // close submenu if needed
            }
        }

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);


    const accessToken = Cookies.get("idToken"); // or from acquireTokenSilent()
    const tokenClaims = parseJwt(accessToken);

    const currentOid = tokenClaims.oid || tokenClaims.sub;

    function parseJwt(token) {
        try {
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map(function (c) {
                        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join("")
            );
            return JSON.parse(jsonPayload);
        } catch (e) {
            return {};
        }
    }

    function extractRolesFromClaims(claims) {
        const roleKeys = ["roles", "role", "http://schemas.microsoft.com/ws/2008/06/identity/claims/role", "extension_Role", ["jobTitle"]];
        let roles = [];
        for (const key of roleKeys) {
            const val = claims[key];
            if (!val) continue;
            if (Array.isArray(val)) roles = roles.concat(val);
            else if (typeof val === "string") {
                if (val.includes(",")) roles = roles.concat(val.split(",").map(s => s.trim()));
                else roles.push(val);
            }
        }
        return roles.map(r => (r || "").toString().toLowerCase());
    }
    // helper to check JWT expiry quickly (client-side convenience)
    function isJwtExpired(token) {
        if (!token) return true;
        try {
            const payload = parseJwt(token);
            if (!payload || !payload.exp) return true;
            // exp is seconds since epoch
            return Date.now() / 1000 >= payload.exp - 30; // consider a 30s safety window
        } catch (e) {
            return true;
        }
    }
    let _interactionInProgress = false;

    function isMsalInteractionPending() {
        // msal stores this key in sessionStorage (your screenshot shows msal.interaction.status)
        try {
            if (sessionStorage.getItem('msal.interaction.status')) return true;
            if (localStorage.getItem('msal.interaction.status')) return true;
            return document.cookie.split(';').some(c => c.trim().startsWith('msal.interaction.status='));
        } catch (e) {
            return false;
        }
    }
    // user-visible toast helper (uses react-toastify)
    function showPopupOpenToast() {
        toast.info("A sign-in window is already open — please complete it.", {
            position: "top-right",
            autoClose: 4000,
            pauseOnHover: true,
            closeOnClick: true
        });
        toast.error("A sign-in window is already open — please complete it.", {
            position: "top-right",
            autoClose: 4000,
            pauseOnHover: true,
            closeOnClick: true
        });
    }
    // WARNING: This is client-side cleanup only. It does NOT log the user out at the identity provider.
    function removeAccountFromMsalCache(account) {
        if (!account) return;

        const homeAccountId = account.homeAccountId || account.localAccountId || account.accountIdentifier || account.idToken?.oid;
        if (!homeAccountId) {
            console.warn('removeAccountFromMsalCache: could not find homeAccountId on account', account);
            return;
        }
        // Helper: remove keys that reference the homeAccountId
        const removeKeysContaining = (storage) => {
            try {
                Object.keys(storage).forEach((k) => {
                    try {
                        const v = storage.getItem(k) || "";
                        // if the serialized value references the homeAccountId, remove it
                        if (typeof v === "string" && v.includes(homeAccountId)) {
                            storage.removeItem(k);
                        }
                    } catch (inner) {
                        // ignore parsing errors
                    }
                });
            } catch (e) {
                // ignore storage access errors in some environments
            }
        };

        // remove from sessionStorage and localStorage
        removeKeysContaining(sessionStorage);
        removeKeysContaining(localStorage);
        // Some MSAL builds also use cookies for interaction status — optionally remove cookie entries
        try {
            document.cookie.split(";").forEach(c => {
                const name = c.split("=")[0]?.trim();
                if (!name) return;
                // if cookie name includes homeAccountId or is msal account/token keys, clear it
                if (name.includes(homeAccountId) || name.toLowerCase().includes('msal')) {
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
                }
            });
        } catch (e) { /* ignore cookie errors */ }

        // Finally, ensure the active account is set back to your primary actor (if you have it)
        try {
            const accounts = b2cInstance.getAllAccounts();
            // pick the first non-removed account as active
            const remaining = accounts.find(a => a.homeAccountId && a.homeAccountId !== homeAccountId);
            if (remaining) b2cInstance.setActiveAccount(remaining);
            else b2cInstance.setActiveAccount(null);
        } catch (e) {
            // ignore
        }
    }
    const joinAnotherOrganization = async () => {
        if (isLoginInProgress) return;

        if (!canAddLinkedOrganization(accounts)) {
            toast.error(getLinkedOrganizationLimitValidationMessage(), {
                position: "top-right",
                autoClose: 5000,
            });
            return;
        }

        setIsLoginInProgress(true);
        if (_interactionInProgress) {
            showPopupOpenToast();
            setIsLoginInProgress(false);
            return;
        }
        // check MSAL storage flag (covers popups opened in other tabs/windows or stale flags)
        if (isMsalInteractionPending()) {
            showPopupOpenToast();
            setIsLoginInProgress(false);
            return;
        }
        _interactionInProgress = true;
        try {
            // 0) actor token from cookie (fallback)
            const actorAccessToken = Cookies.get("idToken"); // your cookie name
            const apiScope = `api://${clientIdB2C}/access_as_user`;
            let apiTokenForActor = null;
            // If cookie token exists and not expired, use it (convenience).
            if (actorAccessToken && !isJwtExpired(actorAccessToken)) {
                apiTokenForActor = actorAccessToken;
            } else {
                // If no valid cookie token, ensure there's an active MSAL account and get an access token interactively.
                // This will show a popup to the primary account (actor).
                let currentAccount = b2cInstance.getActiveAccount();
                if (!currentAccount) {
                    const accounts = b2cInstance.getAllAccounts();
                    if (accounts.length > 0) {
                        currentAccount = accounts[0];
                        b2cInstance.setActiveAccount(currentAccount);
                    }
                }
                // Acquire actor access token interactively (no silent attempt)
                if (currentAccount) {
                    try {
                        const silentResp = await b2cInstance.acquireTokenSilent({
                            scopes: [apiScope],
                            account: currentAccount
                        });
                        apiTokenForActor = silentResp?.accessToken;
                    } catch (silentErr) {
                        toast.info("Token is expire ,Please complete sign-in to continue.");
                        // silent failed; we will fall back to interactive below
                        console.debug("acquireTokenSilent failed, will try interactive if needed:", silentErr?.errorCode || silentErr?.message || silentErr);
                    }
                }
            }
            if (!apiTokenForActor) {
                toast.info("Token is expire ,Please complete sign-in to continue.");
                handleLogout();
            }
            // 3) interactive sign-in for the second identity (organization) - get id_token
            var secondLoginResp
            try {
                secondLoginResp = await b2cInstance.loginPopup({ ...signinRequest, prompt: "select_account" });
            }
            catch (err) {
                if (err.errorCode === "interaction_in_progress") {
                    clearMsalInteractionFlag();
                    secondLoginResp = await b2cInstance.loginPopup({ ...signinRequest, prompt: "select_account" });
                }
                throw err;
            }
            const idTokenClaims = secondLoginResp.idTokenClaims || (secondLoginResp.idToken ? parseJwt(secondLoginResp.idToken) : {});
            const secondAccount = secondLoginResp.account;
            const secondIdToken = secondLoginResp.idToken;
            if (!secondIdToken) {
                throw new Error("Failed to obtain second user's id_token.");
            }
            // Optional: UI/UX check - compare roles client-side if desired (but backend must authorize)
            const primaryClaims = parseJwt(apiTokenForActor);
            const primaryRoles = extractRolesFromClaims(primaryClaims);
            const secondRoles = extractRolesFromClaims(idTokenClaims);
            const primaryOid = primaryClaims?.oid || primaryClaims?.sub;
            const secondOid = idTokenClaims?.oid || idTokenClaims?.sub;
            if (primaryOid && secondOid && primaryOid === secondOid) {
                toast.info("Cannot link the same account to itself.", {
                    position: "top-right",
                    autoClose: 4000,
                });
                removeAccountFromMsalCache(secondAccount);
                return;
            }
            if (primaryRoles.length > 0 && secondRoles.length > 0) {
                const sameRole = primaryRoles.some(r => secondRoles.includes(r));
                if (!sameRole) {
                    try { await b2cInstance.logoutPopup({ account: secondAccount }); } catch (e) {/*ignore*/ }
                    toast.error("Second account role does not match. Access denied.");
                    return;
                }
            }
            // 4) call backend to link identity (actor token in Authorization; send second id_token for validation)
            const payload = {
                idToken: secondIdToken, // backend will validate
                secondUser: {
                    oid: idTokenClaims.oid || idTokenClaims.sub,
                    email: idTokenClaims.emails?.[0] || idTokenClaims.email,
                    name: idTokenClaims.name || idTokenClaims.preferred_username
                },
                requestedRole: primaryRoles[0] || "member"
            };
            let linkedLLCsFromApi = [];
            try {
                const res = await fetch(`${hostPath}/api/linkIdentity`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "secondIdToken": `Bearer ${apiTokenForActor}`
                    },
                    body: JSON.stringify(payload)
                });

                // Handle non-200 status codes
                if (!res.ok) {
                    const errorBody = await res.json().catch(() => null);

                    const backendMsg =
                        errorBody?.message ||
                        errorBody?.error ||
                        errorBody?.Message ||
                        res.statusText ||
                        "Link failed";

                    throw new Error(backendMsg);
                }
                // SUCCESS → read backend content
                const data = await res.json();
                linkedLLCsFromApi =
                    data?.linkRecord?.linkedLLCs ||
                    data?.linkRecord?.LinkedLLCs ||
                    data?.linkedLLCs ||
                    data?.LinkedLLCs ||
                    [];
                // Show backend message EXACTLY
                toast.success(data?.message || "Organization linked successfully.");
            } catch (err) {
                toast.error(err.message || "Something went wrong");
                console.error("Link failed:", err);
                removeAccount({
                    oid: idTokenClaims.oid || idTokenClaims.sub,
                    emailId: idTokenClaims.emails?.[0] || idTokenClaims.email
                });
                return;
            }

            // Pick ONLY the newly-added account (the second user) from linkedLLCs
            const secondOidForLookup = idTokenClaims.oid || idTokenClaims.sub;
            const secondEmailForLookup = idTokenClaims.emails?.[0] || idTokenClaims.email;
            const matched = (linkedLLCsFromApi || []).find(
                a =>
                    (a.oid || a.Oid) === secondOidForLookup ||
                    (a.emailId || a.EmailId || a.email) === secondEmailForLookup
            );

            const newAccount = matched
                ? {
                    oid: matched.oid || matched.Oid || secondOidForLookup,
                    emailId: matched.emailId || matched.EmailId || matched.email || secondEmailForLookup,
                    role: matched.role || matched.Role || secondRoles[0] || "",
                    companyName: matched.companyName || matched.CompanyName || "",
                    firstName: matched.firstName || matched.FirstName || "",
                    lastName: matched.lastName || matched.LastName || ""
                }
                : {
                    // Fallback: API didn't return a matching entry. Do NOT use idTokenClaims.name as companyName.
                    oid: secondOidForLookup,
                    emailId: secondEmailForLookup,
                    role: secondRoles[0] || "",
                    companyName: "",
                    firstName: (idTokenClaims.name || "").split(" ")[0] || "",
                    lastName: (idTokenClaims.name || "").split(" ").slice(1).join(" ") || ""
                };

            if (wouldExceedLinkedOrganizationLimit(accounts, newAccount)) {
                toast.error(getLinkedOrganizationLimitValidationMessage(), {
                    position: "top-right",
                    autoClose: 5000,
                });
                removeAccount(newAccount);
                return;
            }

            setAccounts(prev => {
                let updated = [...(prev || [])];
                // Ensure current user is in the list
                const currentInList = updated.some(a => (a.oid || a.Oid) === primaryOid);
                if (!currentInList && primaryOid) {
                    const currentUser = employeeData || userDetails || empDetails;
                    updated.push({
                        oid: primaryOid,
                        emailId: currentUser?.emailId || currentUser?.email || currentUser?.companyEmail || primaryClaims?.emails?.[0] || "",
                        firstName: currentUser?.firstName || currentUser?.empFirstName || (primaryClaims?.name || "").split(" ")[0] || "",
                        lastName: currentUser?.lastName || currentUser?.empLastName || (primaryClaims?.name || "").split(" ").slice(1).join(" ") || "",
                        companyName: currentUser?.companyName || currentUser?.entityName || "",
                        role: currentUser?.title || primaryRoles[0] || "Employee"
                    });
                }
                // Upsert the new account: if it already exists (e.g., from a previous
                // attempt with stale data in sessionStorage), MERGE the API values in
                // so companyName etc. get upgraded with the authoritative server value.
                const idx = updated.findIndex(
                    a =>
                        (a.oid || a.Oid) === newAccount.oid ||
                        (a.emailId || a.EmailId) === newAccount.emailId
                );
                if (idx >= 0) {
                    updated[idx] = {
                        ...updated[idx],
                        ...newAccount,
                        // Prefer non-empty new values, but keep existing if new is empty.
                        companyName: newAccount.companyName || updated[idx].companyName || "",
                        firstName: newAccount.firstName || updated[idx].firstName || "",
                        lastName: newAccount.lastName || updated[idx].lastName || "",
                        role: newAccount.role || updated[idx].role || ""
                    };
                } else if (newAccount.oid || newAccount.emailId) {
                    updated.push(newAccount);
                }
                return updated;
            });
        }
        catch (err) {
            console.error("joinAnotherOrganization failed", err);
            toast.error(err.message || "Operation failed");
        } finally {
            _interactionInProgress = false;
            setIsLoginInProgress(false);
        }
    };

    function clearMsalInteractionFlag() {
        // Remove MSAL interaction status from sessionStorage
        for (const key of Object.keys(sessionStorage)) {
            if (key === "msal.interaction.status") {
                sessionStorage.removeItem(key);
            }
        }
        // Remove from localStorage if present
        for (const key of Object.keys(localStorage)) {
            if (key === "msal.interaction.status") {
                localStorage.removeItem(key);
            }
        }
        // Remove from cookies if MSAL stored it there
        document.cookie.split(";").forEach(c => {
            const [name] = c.split("=").map(s => s.trim());
            if (name === "msal.interaction.status") {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
            }
        });
    }
    // helper to parse JWT if needed (quick utility)  
    async function handleSwitchOrg(linkInfo) {
        if (_interactionInProgress) {
            console.warn("Interactive auth already in progress.");
            return;
        }
        _interactionInProgress = true;
        try {
            const normalizedTarget = normalizeLinkedAccount(linkInfo);
            if (accountsMatch(normalizedTarget, { oid: currentOid })) {
                return { success: true };
            }

            const actorAccessToken = Cookies.get("idToken"); // your cookie name
            const apiScope = `api://${clientIdB2C}/access_as_user`;
            let apiTokenForActor = null;
            // If cookie token exists and not expired, use it (convenience).
            if (actorAccessToken && !isJwtExpired(actorAccessToken)) {
                apiTokenForActor = actorAccessToken;
            } else {
                // If no valid cookie token, ensure there's an active MSAL account and get an access token interactively.
                // This will show a popup to the primary account (actor).
                let currentAccount = b2cInstance.getActiveAccount();
                if (!currentAccount) {
                    const accounts = b2cInstance.getAllAccounts();
                    if (accounts.length > 0) {
                        currentAccount = accounts[0];
                        b2cInstance.setActiveAccount(currentAccount);
                    } else {
                        // No actor session in MSAL, ask the user to sign in first (interactive)
                        // You can choose to open a loginPopup here to sign-in the actor.
                        const loginResp = await b2cInstance.loginPopup(signinRequest);
                        currentAccount = loginResp.account;
                        b2cInstance.setActiveAccount(currentAccount);
                    }
                }
                // Acquire actor access token interactively (no silent attempt)
                try {
                    const tokenResp = await b2cInstance.acquireTokenPopup({
                        scopes: [apiScope],
                        account: currentAccount,
                    });
                    apiTokenForActor = tokenResp?.accessToken;
                } catch (acquireErr) {
                    console.error("Interactive actor token acquire failed", acquireErr);
                    throw new Error("Could not obtain actor token. Please sign in.");
                }
            }

            if (!apiTokenForActor) {
                throw new Error("Missing actor access token. Please sign in.");
            }

            const freshLinkedAccounts = await fetchActiveLinkedAccounts();
            const targetIsStillLinked = freshLinkedAccounts.some(account => accountsMatch(account, normalizedTarget));

            if (!targetIsStillLinked) {
                removeAccount(normalizedTarget);
                toast.error("This organization is no longer available.");
                return { success: false, error: "Organization is no longer linked." };
            }

            setAccounts(prev => {
                const currentAccount = prev.find(account => accountsMatch(account, { oid: currentOid })) || null;
                return upsertPrimaryAccount(freshLinkedAccounts, currentAccount);
            });

            const signinReq = {
                loginHint: linkInfo.emailId,
                authority: process.env.REACT_APP_SIGNIN_AUTHORITY,
                scopes: ["openid", "offline_access", process.env.REACT_APP_API_SCOPE],
                prompt: "login",
                redirectUri: `${window.location.origin}/dashboard`,
            };
            const secondLoginResp = await b2cInstance.loginPopup(signinReq);
            // 4) We have the second token and account
            const secondAccount = secondLoginResp.account;
            const secondAccessToken = secondLoginResp.accessToken || secondLoginResp.idToken || null;
            console.log("Second account signed in:", secondAccount);
            Cookies.remove("idToken"); // remove old primary token cookie
            if (secondAccessToken) {
                Cookies.set("idToken", secondAccessToken); // demo: set second as idToken cookie
            }
            // 6) Set MSAL active account to the second account so subsequent acquireTokenSilent uses it
            if (secondAccount) {
                b2cInstance.setActiveAccount(secondAccount);
            }
            window.location.reload();
            return { success: true, account: secondAccount, accessToken: secondAccessToken };
        } catch (err) {
            console.error("handleSwitchOrg error:", err);
            return { success: false, error: err.message || err };
        } finally {
            // release guard
            setTimeout(() => { _interactionInProgress = false; }, 500);
        }
    }

    const accountFallbackFromUser = (ud = {}) => ({
        oid: ud?.oid || ud?.id || null,
        companyName: ud?.companyName || ud?.entityName || ud?.company || "",
        firstName: ud?.firstName || ud?.first || "",
        lastName: ud?.lastName || ud?.last || "",
        emailId: ud?.email || ud?.emailId || "",
        role: ud?.role || ud?.title || "",
    });

    useEffect(() => {
        if (empDetails?.companyEmail?.includes("@geoparking.com")) return;

        let cancelled = false;
        const loadLinkedAccounts = async () => {
            try {
                const freshLinkedAccounts = await fetchActiveLinkedAccounts();
                if (cancelled) return;

                const currentUser = employeeData || userDetails || empDetails;
                const currentAccount = currentUser
                    ? {
                        ...accountFallbackFromUser(currentUser),
                        oid: currentOid || currentUser?.oid || currentUser?.id,
                    }
                    : null;

                setAccounts(upsertPrimaryAccount(freshLinkedAccounts, currentAccount));
            } catch (error) {
                console.error("Unable to refresh linked organizations:", error);
                if (!cancelled) setAccounts([]);
            }
        };

        loadLinkedAccounts();
        return () => {
            cancelled = true;
        };
    }, [currentOid, employeeData, userDetails, empDetails]);
    // const normalizedAccounts = accounts || [];
    // const primaryAccount =
    //     normalizedAccounts.find(a => a.oid === currentOid) ||
    //     normalizedAccounts[0] ||
    //     (employeeData ? accountFallbackFromUser(employeeData) : null) ||
    //     (userDetails ? accountFallbackFromUser(userDetails) : null);

    const initials = (name = "") => {
        if (!name) return "NA";
        const parts = name.trim().split(/\s+/);
        if (parts.length === 1) return (parts[0].slice(0, 2) || "").toUpperCase();
        return (parts[0][0] + parts[1][0]).toUpperCase();
    };

    // Build a human-friendly display name from an email when name fields are missing.
    // e.g. "shivaprasad.gangadevi@peopletech.com" -> "Shivaprasad Gangadevi"
    const displayNameFromEmail = (email = "") => {
        if (!email || typeof email !== "string") return "";
        const local = email.split("@")[0] || "";
        if (!local) return "";
        return local
            .split(/[._\-+]/)
            .filter(Boolean)
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ");
    };

    // Resolve the best display name for an account entry.
    const resolveDisplayName = (acc = {}) => {
        const full = `${acc.firstName ?? ""} ${acc.lastName ?? ""}`.trim();
        return full || acc.companyName || displayNameFromEmail(acc.emailId) || acc.emailId || "";
    };

    const normalized = (accounts || []).map(a => ({
        oid: a.oid || a.Oid || null,
        emailId: a.emailId || a.EmailId || a.email || null,
        role: a.role || a.Role || a.title || "",
        companyName: a.companyName || a.CompanyName || a.entityName || a.company || "",
        firstName: a.firstName || a.FirstName || a.first || "",
        lastName: a.lastName || a.LastName || a.last || ""
    }));
    const map = new Map();
    normalized.forEach(a => {
        const key = a.oid || a.emailId;
        if (key && !map.has(key)) map.set(key, a);
    });
    const list = Array.from(map.values());

    let primary = list.find(x => x.oid === currentOid) || list[0] || null;
    if (!primary) {
        if (employeeData) primary = accountFallbackFromUser(employeeData);
        else if (userDetails) primary = accountFallbackFromUser(userDetails);
    }

    const others = (list.length > 0 && primary)
        ? list.filter(a => a.oid !== primary.oid)
        : [];

    // build display name & initials for primary
    const currentDisplayName = primary ? resolveDisplayName(primary) : "";

    const currentInitial = initials(currentDisplayName || employeeData?.entityName || userDetails?.entityName);
    const canLinkAnotherOrganization = canAddLinkedOrganization(list);
    const linkedOrganizationLimitMessage = getLinkedOrganizationLimitValidationMessage();


    return (
        <nav className="navbar">
            {/* <ToastContainer /> */}
            {/* Navbar logo and links */}
            <div className="navbar-logo">
                <img src={logo} alt="Logo" />
            </div>
            {envname && <span className="restricted-badge-navbar">{envname}</span>}
            <div className="navbar-links">
                {(empDetails || userDetails || employeeData) && (
                    <>
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) => (isActive ? 'selected' : '')}
                            onClick={(e) => handleNavigation(e, "/dashboard")}

                        >
                            Dashboard
                        </NavLink>

                        {userDetails && (!empDetails || !empDetails?.companyEmail?.includes('@geoparking.com')) && (
                            <>
                                <NavLink
                                    to="/viewparkinginfo"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/viewparkinginfo")}
                                >
                                    My Properties
                                </NavLink>
                                <NavLink
                                    to="/EmployeeRegistrationDashboard"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/EmployeeRegistrationDashboard")}
                                >
                                    Employee Registration Dashboard
                                </NavLink>
                                <NavLink to="/earnings" className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/earnings")}
                                >
                                    Earnings
                                </NavLink>
                            </>
                        )}
                        {
                            employeeData && (!empDetails || !empDetails?.companyEmail?.includes('@geoparking.com')) && (
                                <>
                                    <NavLink
                                        to="/viewparkinginfo"
                                        className={({ isActive }) => (isActive ? 'selected' : '')}
                                        onClick={(e) => handleNavigation(e, "/viewparkinginfo")}
                                    >
                                        My Properties
                                    </NavLink>
                                </>
                            )
                        }

                        {empDetails?.companyEmail?.includes('@geoparking.com') && (
                            <>
                                <NavLink
                                    to="/reviewtab"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/reviewtab")}
                                >
                                    Pending Approval
                                </NavLink>
                                <NavLink
                                    to="/OwnerRegistrationDashboard"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/OwnerRegistrationDashboard")}

                                >
                                    Owner & Property Management
                                </NavLink>
                                <NavLink
                                    to="/Pricing"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/Pricing")}

                                >
                                    Pricing
                                </NavLink>
                                <NavLink
                                    to="/GlobalSearchDashBoard"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/GlobalSearchDashBoard")}

                                >
                                    Global Search
                                </NavLink>
                                <NavLink to="/salesinsights" className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/salesinsights")}

                                >
                                    Sales Insights
                                </NavLink>
                                {tooltip.show && (
                                    <div
                                        className="tooltip-custom"
                                        style={{
                                            top: tooltip.position.top,
                                            left: tooltip.position.left,
                                            transform: "translateX(-50%)",
                                        }}
                                    >
                                        {tooltip.text}
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>

            <div className="profile-dropdown" ref={rootRef}>
                <div
                    className="profile-icon"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(prev => !prev);
                    }}
                    role="button"
                    tabIndex={0}
                >
                    {initial}
                </div>

                {isOpen && (
                    <ul className="submenu" onClick={(e) => e.stopPropagation()}>
                        {/* Current Organization */}

                        {/* Add / Geoparking block */}
                        {empDetails?.companyEmail?.includes("@geoparking.com") ? (
                            // Geoparking users: compact admin links
                            <>
                                <li className="submenu-section">
                                    <ul className="geoparking-links">
                                        <li className="account-item">
                                            <a href="/login" onClick={handleLogout}>
                                                Logout
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="divider" />
                            </>
                        ) : (
                            // Regular users: join button + account settings + invoices + logout
                            <>
                                <li className="submenu-section">
                                    <div className="section-title">CURRENT ORGANIZATION</div>

                                    <div
                                        className="organization current-org"
                                        onClick={() => {
                                            if (primary) handleSwitchOrg(primary);
                                            setIsOpen(false);
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        <div className="org-avatar">{currentInitial}</div>

                                        <div className="org-details">
                                            <div className="org-name">
                                                {employeeData
                                                    ? // Employee logged in (e.g., sravani) — show first+last name
                                                      (`${employeeData?.firstName ?? employeeData?.empFirstName ?? primary?.firstName ?? ""} ${employeeData?.lastName ?? employeeData?.empLastName ?? primary?.lastName ?? ""}`.trim() ||
                                                       primary?.companyName ||
                                                       employeeData?.entityName ||
                                                       primary?.emailId ||
                                                       "Unknown")
                                                    : // Owner logged in (e.g., shiva) — show company / entity name, never the email
                                                      (primary?.companyName ||
                                                       userDetails?.entityName ||
                                                       userDetails?.companyName ||
                                                       `${primary?.firstName ?? ""} ${primary?.lastName ?? ""}`.trim() ||
                                                       `${userDetails?.firstName ?? ""} ${userDetails?.lastName ?? ""}`.trim() ||
                                                       primary?.emailId ||
                                                       "Unknown")}
                                            </div>

                                            <div className="org-meta">
                                                <span className="org-role">
                                                    {primary?.role || employeeData?.title || userDetails?.title || ""}
                                                </span>
                                                <span className="org-status">
                                                    <span className="dot" /> Active
                                                </span>
                                            </div>
                                        </div>

                                        <div className="checkmark">✔</div>
                                    </div>
                                </li>

                                <li className="divider" />

                                {/* SWITCH ORGANIZATIONS (only if others exist) */}
                                {others.length > 0 && (
                                    <>
                                        <li className="submenu-section">
                                            <div className="section-title switch-title">SWITCH ORGANIZATION</div>
                                            {others.map((org, idx) => {
                                                const key = org.oid || org.emailId || `org-${idx}`;
                                                // Prefer companyName (owner). For employees with empty
                                                // companyName, fall back to firstName + lastName. Only use
                                                // the email-derived name if both are missing.
                                                const fullName = `${org.firstName ?? ""} ${org.lastName ?? ""}`.trim();
                                                const displayLabel =
                                                    org.companyName ||
                                                    fullName ||
                                                    displayNameFromEmail(org.emailId) ||
                                                    org.emailId ||
                                                    "";
                                                const avatarSeed = org.companyName || fullName || displayNameFromEmail(org.emailId) || org.emailId || "";

                                                return (
                                                    <div
                                                        key={key}
                                                        className="organization"
                                                        onClick={() => {
                                                            handleSwitchOrg(org);
                                                            setIsOpen(false);
                                                        }}
                                                        role="button"
                                                        tabIndex={0}
                                                    >
                                                        <div className="org-avatar alt">{initials(avatarSeed)}</div>
                                                        <div className="org-details">
                                                            <div className="org-name">{displayLabel}</div>
                                                            <div className="org-meta">
                                                                <span className="org-role">{org.role || ""}</span>
                                                                <span className="org-status">
                                                                    <span className="dot" /> Active
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </li>

                                        <li className="divider" />
                                    </>
                                )}

                                <li className="submenu-section">
                                    <button
                                        className={`join-org-btn${canLinkAnotherOrganization ? "" : " is-disabled"}`}
                                        disabled={!canLinkAnotherOrganization}
                                        title={
                                            canLinkAnotherOrganization
                                                ? ""
                                                : linkedOrganizationLimitMessage
                                        }
                                        onClick={() => {
                                            if (!canLinkAnotherOrganization) {
                                                toast.error(linkedOrganizationLimitMessage, {
                                                    position: "top-right",
                                                    autoClose: 5000,
                                                });
                                                return;
                                            }
                                            joinAnotherOrganization();
                                            setIsOpen(false);
                                        }}
                                    >
                                        {userPlus && <img src={userPlus} alt="join" />}
                                        Add Another Organization
                                    </button>
                                    {!canLinkAnotherOrganization && (
                                        <div className="linked-org-limit-note">
                                            {linkedOrganizationLimitMessage}
                                        </div>
                                    )}
                                </li>

                                <li className="divider" />

                                {/* Account Settings */}
                                <li className="submenu-section account-settings">
                                    <div
                                        className="account-header"
                                        onClick={() => setIsAccountSettingsOpen(!isAccountSettingsOpen)}
                                    >
                                        <div className="account-header-left">
                                            <img src={user} alt="userIcon" className="account-icon" />
                                            <span className="account-title">Account Settings</span>
                                        </div>
                                        <span className="account-toggle">{isAccountSettingsOpen ? "▴" : "▾"}</span>
                                    </div>

                                    {isAccountSettingsOpen && (
                                        <ul className="account-inner">
                                            <li className="account-item">
                                                <NavLink to="/settings/entity"
                                                    className={({ isActive }) => `sideHeader ${isActive ? "active" : ""}`}
                                                    onClick={() => setIsOpen(false)}
                                                >
                                                    Entity Information
                                                </NavLink>
                                            </li>
                                            <li className="divider-line" />

                                            <li className="account-item">
                                                <NavLink to="/settings/profile" className={({ isActive }) => `sideHeader ${isActive ? "active" : ""}`} onClick={() => setIsOpen(false)}>
                                                    Profile Information
                                                </NavLink>
                                            </li>
                                            <li className="divider-line" />

                                            <li className="account-item">
                                                <NavLink to="/settings/password" className={({ isActive }) => `sideHeader ${isActive ? "active" : ""}`} onClick={() => setIsOpen(false)}>
                                                    Change Password
                                                </NavLink>
                                            </li>
                                        </ul>
                                    )}
                                </li>

                                <li className="divider" />

                                {/* Invoices */}
                                <li className="submenu-section">
                                    <button className="invoice-btn" onClick={() => setIsOpen(false)}>
                                        <img src={copy} alt="reports" className="invoice-icon" />
                                        Invoices and Reports
                                    </button>
                                </li>

                                <li className="divider" />

                                {/* Logout */}
                                <li className="submenu-section">
                                    <button
                                        className="logout-btn"
                                        onClick={() => {
                                            handleLogout();
                                            setIsOpen(false);
                                        }}
                                    >
                                        ↪ Logout
                                    </button>
                                </li>
                            </>
                        )}
                    </ul>
                )}


            </div>
            {showPopup1 && (
                <div className="custom-popup">
                    <div className="popup-text">
                        <p>All unsaved progress will be lost. Are you sure you want to continue?</p>
                        <div className="popup-buttons">
                            <button className="confirm-btn" onClick={handleConfirmNavigate}>
                                Continue
                            </button>
                            <button className="cancel-btn" onClick={handleCancelNavigate}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showPopup && (
                <div className="custom-popup">
                    <div className="popup-text">
                        <p>Are you still there? You will be logged out in {countdown} seconds.</p>
                        <div className="popup-buttons">
                            <button className="confirm-btn" onClick={handleStayLoggedIn}>
                                Stay Logged In
                            </button>
                            <button className="cancel-btn" onClick={handleLogout}>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {openDialog && (
                <>
                    <div className="custom-popup">
                        <div className="popup-text-warning">
                            <h3 className="popup-warning"><img src={warniningIcon} /> Warning!</h3>
                            <Divider
                                sx={{
                                    width: "100%",
                                    height: "2px",
                                    backgroundColor: "#8B8B8B",
                                    borderRadius: "1px",
                                    marginTop: "10px"
                                }}
                            />
                            <span style={{ padding: '25px' }}>{PopUPModal.Alert_dialog_description}</span>

                            <div className="popup-buttons">
                                <button className="confirm-btn" onClick={handleConfirmNavigation}>
                                    Continue
                                </button>
                                <button className="cancel-btn" onClick={handleCancelNavigate}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )
            }

        </nav >
    );
};

export default Navbar;
